import React, { useEffect } from 'react';

import { Box, ButtonBase, Grid, Typography } from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../../assets/img/icon/Right.svg';
import SuraCard from '../../../../components/SuraCard';
import { incidentRoad } from '../../../../constants/incidents.constant';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import ComplaintValidation from './ComplaintValidation.component';
import SelectMyDamages from './SelectMyDamages.component';

const TypeOfDamage = () => {
  const { nextStep, updateSinisterBody, sinister_body } =
    useSinisterDataContext();

  let robbery: { [index: string]: any } = incidentRoad.robbery;

  const steps = {
    hasDamage: [
      {
        title: 'tipo de daños',
        content: <SelectMyDamages />,
        order: sinister_body?.robbery?.type === 'total' ? 11 : 8,
      },
    ],
    hasNoDamage: [
      {
        title: 'tipo de daños',
        content: <SelectMyDamages />,
        order: 9,
      },
    ],
    conditionalStep: [
      {
        title: 'Como actuar',
        content: <ComplaintValidation />,
        order: 9,
      },
    ],
  };

  useEffect(() => {
    //TODO: fix this bad assignation
    robbery = incidentRoad.robbery;

    // robbery.map((element: any, key: any) => {
    //   if (sinister_body?.robbery.type === 'partial') {
    //     if (element?.title === "Como actuar" || element?.title === "Denuncia Policial") {
    //       robbery.splice(key, 1);
    //     }

    //   }
    // });
    // robbery = robbery.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));
  }, []);

  const selectCard = (hasDamge: boolean) => {
    let keytodelete = null;
    robbery = incidentRoad.robbery;

    if (hasDamge) {
      if (
        !robbery.find(
          (element: { title: any }) => element.title === 'tipo de daños'
        )
      ) {
        steps.hasDamage.forEach((step) => {
          robbery.push(step);
        });
      } else {
        robbery.forEach((element: any, key: any) => {
          if (element.title === 'tipo de daños') {
            keytodelete = key;
          }
        });
      }
    }
    if (!hasDamge) {
      updateSinisterBody({ ...sinister_body, damage: {} });
      robbery.forEach((element: any, key: any) => {
        if (element.title === 'tipo de daños') {
          keytodelete = key;
        }
      });
    }

    if (
      sinister_body?.robbery?.tire === true &&
      sinister_body?.robbery?.tires?.tires_selected >= 3
    ) {
      if (
        !robbery.find(
          (element: { title: any }) => element?.title === 'Como actuar'
        )
      ) {
        steps.conditionalStep.forEach((step) => {
          robbery.push(step);
        });
      }
    }

    if (keytodelete) robbery.splice(keytodelete, 1);

    robbery = robbery.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));
    robbery = robbery.filter((item: any, index: any) => {
      return robbery.indexOf(item) === index;
    });
    nextStep();
  };

  return (
    <>
      <Grid item xs={12} sm={6}>
        <Box>
          <Box my={4}>
            <Typography variant="h6" color="textPrimary">
              ¿El vehículo sufrió daños?
            </Typography>
          </Box>
          <Box mr={3} mb={3}>
            <ButtonBase
              style={{ width: '100%' }}
              onClick={() => selectCard(true)}
            >
              <SuraCard style={{ width: '100%' }}>
                <Box
                  m={3}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  width={'100%'}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box ml={1}>
                      <Typography variant="body1">Sí, sufrió daños</Typography>
                    </Box>
                  </Box>
                  <Box>
                    <RightIcon></RightIcon>
                  </Box>
                </Box>
              </SuraCard>
            </ButtonBase>
          </Box>

          <Box mr={3} mb={3}>
            <ButtonBase
              style={{ width: '100%' }}
              onClick={() => selectCard(false)}
            >
              <SuraCard
                // className={
                //   sinister_body[relatedField] === card.value
                //     ? classes.selectedCard
                //     : ""
                // }
                style={{ width: '100%' }}
              >
                <Box
                  m={3}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  width={'100%'}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box ml={1}>
                      <Typography variant="body1">No sufrió daños</Typography>
                    </Box>
                  </Box>
                  <Box>
                    <RightIcon></RightIcon>
                  </Box>
                </Box>
              </SuraCard>
            </ButtonBase>
          </Box>
        </Box>
      </Grid>
      <Box mr={2} my={2}>
        <Typography>
          {' '}
          Tené en cuenta que la cobertura de daños queda sujeto a análisis según
          el tipo de cobertura.{' '}
        </Typography>
      </Box>
    </>
  );
};

export default TypeOfDamage;
